var SharedFooterUSMainView, StepTwoInbentaNLPView, StepTwoInbentaNonNLPView, StepTwoV1CMSView, SupportCMSModel, SupportHorizontalViewManagerBase, SupportInbentaModel, SupportV2OptimizedContactChannelsModel, SupportV2StepActionsModel, SupportV2StepOneView, SupportV2USStepThreeView, SupportV2USViewManager,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportHorizontalViewManagerBase = require('../horizontal_view_manager_base');

SupportV2StepOneView = require('../../views/step_one/v2_view');

SupportV2StepActionsModel = require('../../models/v2_step_action');

SupportV2USStepThreeView = require('../../views/step_three/US/v2_view');

SharedFooterUSMainView = require('../../../../shared/frontend/views/footer/US/main_view');

StepTwoInbentaNLPView = require('../../views/step_two/inbenta/nlp_view');

StepTwoInbentaNonNLPView = require('../../views/step_two/inbenta/non_nlp_view');

StepTwoV1CMSView = require('../../views/step_two/CMS/v1_cms_view');

SupportInbentaModel = require('../../models/Inbenta');

SupportCMSModel = require('../../models/CMS');

SupportV2OptimizedContactChannelsModel = require('../../models/v2_optimized_contact_channels');

SupportV2USViewManager = (function(superClass) {
  extend(SupportV2USViewManager, superClass);

  function SupportV2USViewManager() {
    SupportHorizontalViewManagerBase.prototype.constructor.apply(this, arguments);
    Groupon.Support.stepActionModel = new SupportV2StepActionsModel({
      showHorizontalView: true
    });
  }

  SupportV2USViewManager.prototype.render = function() {
    return this.renderFooter();
  };

  SupportV2USViewManager.prototype.renderFooter = function() {
    var supportFooter;
    supportFooter = new SharedFooterUSMainView();
    supportFooter.render();
    $("#footer-content").html(supportFooter.el);
    return addWrapperLinkOverCallUs();
  };

  SupportV2USViewManager.prototype.getStepOneView = function() {
    return new SupportV2StepOneView({
      showHorizontalView: true
    });
  };

  SupportV2USViewManager.prototype.getStepTwoView = function() {
    var inbentaView;
    return Groupon.Support.StepTwoView = isCMSEnabled() ? new StepTwoV1CMSView({
      dropDownModel: Groupon.Support.ContentModel.dropDowns
    }) : (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled() ? inbentaView = StepTwoInbentaNLPView : inbentaView = StepTwoInbentaNonNLPView, new inbentaView({
      dropDownModel: Groupon.Support.ContentModel.dropDowns,
      dropDownCombinationsModel: Groupon.Support.ContentModel.dropDownCombinations
    }));
  };

  SupportV2USViewManager.prototype.getStepThreeView = function() {
    return new SupportV2USStepThreeView();
  };

  SupportV2USViewManager.prototype.configureContentModel = function() {
    if (isCMSEnabled()) {
      return Groupon.Support.ContentModel = new SupportCMSModel;
    } else {
      return Groupon.Support.ContentModel = new SupportInbentaModel;
    }
  };

  SupportV2USViewManager.prototype.configureOptimizedContactChannelsModel = function() {
    return Groupon.Support.OptimizedContactChannelsModel = new SupportV2OptimizedContactChannelsModel;
  };

  return SupportV2USViewManager;

})(SupportHorizontalViewManagerBase);

module.exports = SupportV2USViewManager;

//# sourceMappingURL=data:application/json;base64,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
